table.root {
  border: 2px solid darkgray;
  border-collapse: collapse;

  td, th {
    border: 1px solid darkgray;
  }
  thead tr:last-child th {
    border-bottom-width: 2px;
  }
  tfoot tr:first-child th {
    border-top-width: 2px;
  }
}
